import { useQuery } from '@tanstack/react-query';

import { RESPONSE_ITEMS_PER_PAGE } from 'src/constants';
import { apiRequest } from 'src/helpers/apiRequest';
import { useAppConfig } from 'src/hooks';
import { ApplicationListResponsePaginationItemsContainer } from 'src/types/rest/tenant';

export const useApplicationLists = () => {
  const {
    tenancy: { apiHost },
  } = useAppConfig();

  return useQuery({
    queryFn: () =>
      apiRequest<ApplicationListResponsePaginationItemsContainer>({
        url: `${apiHost}/application-lists?PageIndex=1&ItemsPerPage=${RESPONSE_ITEMS_PER_PAGE}`,
      }),
    queryKey: ['applicationLists'],
  });
};
